import * as React from 'react';
import Box from '@mui/material/Box';
import MuiCard from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import Button from '@mui/material/Button';
import { FormControl, FormGroup ,FormHelperText,MenuItem,Select,TextField,Typography } from '@mui/material';
import { ICompanyDetails } from '../SignupPage';

const Card = styled(MuiCard)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: '100%',
  minHeight: '300px',
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  [theme.breakpoints.up('sm')]: {
    width: '450px',
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

 const countries = [
    { code: "US", description: "United States" },
    { code: "GB", description: "United Kingdom" },
    { code: "AU", description: "Australia" },
    { code: "AT", description: "Austria" },
    { code: "BE", description: "Belgium" },
    { code: "BR", description: "Brazil" },
    { code: "CA", description: "Canada" },
    { code: "DK", description: "Denmark" },
    { code: "FI", description: "Finland" },
    { code: "FR", description: "France" },
    { code: "DE", description: "Germany" },
    { code: "GI", description: "Gibraltar" },
    { code: "IE", description: "Ireland" },
    { code: "IT", description: "Italy" },
    { code: "JP", description: "Japan" },
    { code: "JE", description: "Jersey" },
    { code: "LU", description: "Luxembourg" },
    { code: "NL", description: "Netherlands" },
    { code: "NZ", description: "New Zealand" },
    { code: "PT", description: "Portugal" },
    { code: "SA", description: "Saudi Arabia" },
    { code: "SG", description: "Singapore" },
    { code: "ES", description: "Spain" },
    { code: "SE", description: "Sweden" },
    { code: "CH", description: "Switzerland" },
    { code: "TR", description: "Turkey" },
];

interface SignupStep2Props {
  onNextClick: (data: ICompanyDetails) => void;
  onPreviousClick: VoidFunction;
  formData : ICompanyDetails;
}

export const SignupStep2 : React.FC<SignupStep2Props> = (props) => {

  const { control, handleSubmit } = useForm<ICompanyDetails>();
  
  const onSubmit: SubmitHandler<ICompanyDetails> = (data) => {
    props.onNextClick(data);
  };
 
  return (
      <form onSubmit={handleSubmit(onSubmit)} style={{ width: "100%" }}>
        <Card variant="outlined">
          <Box sx={{ display: { xs: 'flex' } }}>
            <img src="/logo.png" alt="Logo" style={{ height: 40, paddingBottom:0 }} />  
          </Box>

          <Typography
              component="h1"
              variant="h4"
              sx={{ width: '100%', fontSize: 'clamp(2rem, 10vw, 2.15rem)' }}
              >
            Please enter your company information
          </Typography>

        
            <Controller
              name="name"
              control={control}
              defaultValue={
                props.formData.name === null
                   ? undefined
                   : props.formData.name
              }
              rules={{
                required: {
                  value: true,
                  message: "",
                },
              }}
              render={({ field }) => (
                <TextField
                  name={field.name}
                  value={field.value}
                  size="small"
                  required
                  onChange={field.onChange}
                  id="name"
                  label="Organisation's Name"
                  sx={{ width: "100%", mt: 2 }}
                  helperText=""
                />
              )}
            />

            <Controller
              name="addressLine1"
              control={control}
              defaultValue={
                props.formData.addressLine1 === null
                  ? undefined
                  : props.formData.addressLine1
              }
              render={({ field }) => (
                <TextField
                  name={field.name}
                  value={field.value}
                  size="small"
                  onChange={field.onChange}
                  id="addressLine1"
                  label="Address Line 1"
                  sx={{ width: "100%" }}
                  helperText=""
                />
              )}
            />

            <Controller
              name="addressLine2"
              control={control}
              defaultValue={
                props.formData.addressLine2 === null
                  ? undefined
                  : props.formData.addressLine2
              }
              render={({ field }) => (
                <TextField
                  name={field.name}
                  value={field.value}
                  size="small"
                  onChange={field.onChange}
                  id="addressLine2"
                  label="Address Line 2"
                  sx={{ width: "100%" }}
                  helperText=""
                />
              )}
            />

            <Controller
              name="addressLine3"
              control={control}
              defaultValue={
                props.formData.addressLine3 === null
                  ? undefined
                  : props.formData.addressLine3
              }
              render={({ field }) => (
                <TextField
                  name={field.name}
                  value={field.value}
                  size="small"
                  onChange={field.onChange}
                  id="addressLine3"
                  label="Address Line 3"
                  sx={{ width: "100%" }}
                  helperText=""
                />
              )}
            />

            <Controller
              name="townCity"
              control={control}
              defaultValue={
                props.formData.townCity === null
                  ? undefined
                  : props.formData.townCity
              }
              render={({ field }) => (
                <TextField
                  name={field.name}
                  value={field.value}
                  size="small"
                  onChange={field.onChange}
                  id="townCity"
                  label="Town / City"
                  sx={{ width: "100%" }}
                  helperText=""
                />
              )}
            />

            <Controller
              name="stateCounty"
              control={control}
              defaultValue={
                props.formData.stateCounty === null
                  ? undefined
                  : props.formData.stateCounty
              }
              render={({ field }) => (
                <TextField
                  name={field.name}
                  value={field.value}
                  size="small"
                  id="stateCounty"
                  onChange={field.onChange}
                  label="State / County"
                  sx={{ width: "100%" }}
                  helperText=""
                />
              )}
            />

            <Controller
              name="postalZip"
              control={control}
              defaultValue={
                props.formData.postalZip === null
                  ? undefined
                  : props.formData.postalZip
              }
              render={({ field }) => (
                <TextField
                  name={field.name}
                  value={field.value}
                  size="small"
                  onChange={field.onChange}
                  label="Zip Code / Postal Code"
                  sx={{ width: "100%", mb: 2 }}
                  helperText=""
                />
              )}
            />

            <Controller
              name="country"
              control={control}
              defaultValue={
                props.formData.country === null
                  ? undefined
                  : props.formData.country
              }
              render={({ field }) => (
                <FormControl
                  sx={{ alignContent: "flex-start", width: "100%" }}
                >
                  <Select
                    {...field}
                    size="small"
                    sx={{ width: "50%", alignSelf: "flex-start" }}
                  >
                    {countries.map((country) => {
                      return (
                        <MenuItem key={country.code} value={country.code}>
                          {country.description}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <FormHelperText>Country</FormHelperText>
                </FormControl>
              )}
            />          

          <FormGroup row sx={{justifyContent:'flex-end'}}>
              <Button
                  variant="outlined"
                  color="primary"
                  sx={{ mt: 2, mr: 2 }}
                  onClick={props.onPreviousClick}
              >
                  Previous
              </Button>
              <Button
                  variant="outlined"
                  color="primary"
                  type="submit"
                  sx={{ mt: 2 }}
              >
                  Next
              </Button>
          </FormGroup>
          
        </Card>
      </form>
   
  )
}